import React, { useState } from "react"
import { AnimatePresence } from "framer-motion"
import style from "./navigation.module.scss"
import borduursel from "../assets/svg/borduursel.svg"
import facebook from "../assets/svg/icon_facebook.svg"
import instagram from "../assets/svg/icon_instagram.svg"
import Resultaat from "./resultaat"
import scrollTo from "gatsby-plugin-smoothscroll"
export default function Navigation({ links }) {
  const [showResultaat, setShowResultaat] = useState(true)
  return (
    <>
      <AnimatePresence>
        {showResultaat && <Resultaat></Resultaat>}
      </AnimatePresence>

      <nav className={style.nav}>
        {links.map((linkName, index) => {
          return (
            <div className={style.combine}>
              <a
                className={style.link}
                onClick={() => {
                  linkName !== "resultaat" &&
                    scrollTo(
                      `#${linkName === "wat is weef" ? "watisweef" : linkName}`
                    )

                  linkName !== "resultaat" && setShowResultaat(false)
                  linkName === "resultaat" && setShowResultaat(!showResultaat)
                }}
                style={{
                  gridColumn: { index },
                  pointerEvents: "visible",
                  cursor: "pointer",
                }}
                key={linkName}
              >
                {linkName}
              </a>
              {linkName !== "contact" && (
                <img src={borduursel} alt="borduursel"></img>
              )}
            </div>
          )
        })}
        <a
          className={style.facebook}
          href="https://www.facebook.com/WEEF-103794158088077"
          target="_blank"
          rel="noreferrer"
        >
          <img width="23px" src={facebook} alt="facebook_logo"></img>
        </a>
        <a
          className={style.instagram}
          href="https://www.instagram.com/weef_nu/?hl=nl"
          target="_blank"
          rel="noreferrer"
        >
          <img width="23px" src={instagram} alt="instagram_logo"></img>
        </a>
      </nav>
    </>
  )
}
